<template>
  <div v-if="localTravellersRef && localTravellersRef.length > 0" class="reservation-voucher">
    <div v-if="!state.visible" class="voucher-link" @click="state.visible = true">Použiť kupón</div>

    <div v-else>
      <form class="voucher-form m-b-xs" @submit.prevent="applyVoucher">
        <InputField v-model="state.code" name="code" label="Zadajte kód kupónu" />

        <button type="button" class="btn-primary-border sm" @click="applyVoucher">Uplatniť</button>
      </form>

      <p v-if="state.message !== ''" :class="state.messageType">{{ state.message }}</p>
    </div>

    <slot />
  </div>
</template>

<script lang="ts" setup>
import axios from 'axios';
import { reactive } from 'vue';
import InputField from './input/InputField.vue';
import { useLocalTravellers } from '../modules/useLocalTravellers';
import { useReservation } from '../modules/useReservation';

const state = reactive({
  code: '',
  message: '',
  visible: true,
  messageType: '',
});

const { localTravellersRef } = useLocalTravellers();
const { applyVoucher: applyVoucherToReservation } = useReservation();

const applyVoucher = async () => {
  state.message = '';

  const response = await applyVoucherToReservation(state.code);

  if (response.data.status === 'success') {
    state.code = '';
    state.messageType = 'alert-info';
    state.message = response.data.message;

    setTimeout(() => {
      state.message = '';
    }, 3000);
  } else {
    state.messageType = 'alert-danger';
    state.message = response.data.message;
  }
};
</script>
